import { render, staticRenderFns } from "./DataTableSupportUsers.vue?vue&type=template&id=33c24425"
import script from "./DataTableSupportUsers.vue?vue&type=script&lang=js"
export * from "./DataTableSupportUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports